export const PATH_TYPE = {
  AUDIENCE: 'audience',
  PURPOSE: 'purpose'
}
